import ExchangeJourneySearch from './ExchangeJourneySearch';

export default ExchangeJourneySearch;
